import update from "immutability-helper";
import type { AnyAction } from "redux";
import type { PrepSession } from "@theirstory/common/api_types/backend";

import {
  CONCLUDE_LOADING,
  CONCLUDE_LOADED,
  REFRESH_IMAGE,
  ERROR_WHILE_SAVING,
  UPDATE_CONCLUDE,
  UPDATE_PREPSESSION,
  TRANSCRIBE_SUBMITTED,
  CLEAN_CONCLUDE,
  IS_SAVING_VALUES,
} from "../actions/types";

export interface Prepsession {
  prepsession: PrepSession;
  terms: string;
  termsRequired: boolean;
  require_author_email: boolean;
  prepSessionType: string;
  redirectionUrl: string;
  customUrlTitle: string;
  prepSessionKey: string;
  title: string;
}

export interface Chunk {
  key: string;
  duration: number;
}

export interface ConcludeState {
  isLoadingConclude: boolean;
  isSavingValues: boolean;
  isLoaded: boolean;
  messageOfSavingStatus: string;
  conclude: {
    folders: string[];
    participants: string[];
    recordAgainUrl: string;
    tags: any[];
    emails: any[];
    title: string;
    description: string;
    authorEmail: string;
    notifyGroup: string;
    projects: any[];
    termsAccepted: boolean;
    isUpload: boolean;
    concluded: boolean;
    archiveMediaURL: string;
    posterURL: string;
    notes: "";
    compositionCompleted: boolean;
    dolbyConference: boolean;
    transcribeSubmitted: boolean;
    thumbnailURL: string | null;
    organizationName: string;
    chunks: Chunk[];
  };
  prepsession: Prepsession | null;
}

const initialState: ConcludeState = {
  isLoadingConclude: false,
  isSavingValues: false,
  isLoaded: false,
  messageOfSavingStatus: "All changes saved",
  conclude: {
    folders: [],
    participants: [],
    recordAgainUrl: "",
    tags: [],
    emails: [],
    title: "",
    description: "",
    authorEmail: "",
    notifyGroup: "",
    projects: [],
    termsAccepted: false,
    isUpload: false,
    concluded: false,
    archiveMediaURL: "",
    posterURL: "",
    notes: "",
    compositionCompleted: false,
    dolbyConference: false,
    transcribeSubmitted: false,
    thumbnailURL: null,
    organizationName: "",
    chunks: [],
  },
  prepsession: null,
};

const concludeReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case CONCLUDE_LOADING: {
      return update(state, { isLoadingConclude: { $set: true } });
    }
    case CONCLUDE_LOADED: {
      return update(state, { isLoadingConclude: { $set: false }, isLoaded: { $set: true } });
    }
    case TRANSCRIBE_SUBMITTED: {
      return update(state, { conclude: { transcribeSubmitted: { $set: true } } });
    }
    case UPDATE_CONCLUDE: {
      const {
        participants,
        tags,
        emails,
        title,
        description,
        recordAgainUrl,
        folders,
        authorEmail,
        notifyGroup,
        projects,
        termsAccepted,
        isUpload,
        concluded,
        archiveMediaURL,
        posterURL,
        organizationName,
        chunks,
      } = payload;

      return update(state, {
        conclude: {
          participants: { $set: participants },
          tags: { $set: tags },
          emails: { $set: emails },
          title: { $set: title },
          description: { $set: description },
          recordAgainUrl: { $set: recordAgainUrl },
          folders: { $set: folders },
          authorEmail: { $set: authorEmail },
          notifyGroup: { $set: notifyGroup },
          projects: { $set: projects },
          termsAccepted: { $set: termsAccepted },
          isUpload: { $set: isUpload },
          concluded: { $set: concluded },
          archiveMediaURL: { $set: archiveMediaURL },
          posterURL: { $set: posterURL },
          organizationName: { $set: organizationName },
          chunks: { $set: chunks },
        },
        messageOfSavingStatus: { $set: initialState.messageOfSavingStatus },
      });
    }
    case UPDATE_PREPSESSION: {
      // const { folders}
      return update(state, { prepsession: { $set: payload } });
    }
    case ERROR_WHILE_SAVING: {
      // const { folders}
      return update(state, {
        messageOfSavingStatus: { $set: "Some changes may not be saved" },
        isLoadingConclude: { $set: false },
      });
    }
    case IS_SAVING_VALUES: {
      return update(state, {
        isSavingValues: { $set: payload },
      });
    }
    case REFRESH_IMAGE: {
      return update(state, {
        conclude: {
          archiveMediaURL: { $set: payload.archiveMediaURL },
          compositionCompleted: { $set: payload.compositionCompleted },
          dolbyConference: { $set: payload.dolbyConference },
          thumbnailURL: { $set: payload.thumbnailURL },
        },
      });
    }
    case CLEAN_CONCLUDE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default concludeReducer;
